import { Typography } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import React from 'react';

function Copyright(props) {
    return (
        <React.Fragment>
            <Typography
                variant="body2"
                color="textSecondary"
                align="center"
            >
                {'Copyright © '}
                <Link color="inherit" href="https://ariatech.kr/">
                    주식회사 아리아텍 All rights reserved
                </Link>{' '}
                {new Date().getFullYear()}
                {'.'}
            </Typography>
        </React.Fragment>
    );
}

export default Copyright;
